<app-modal-shell [showFooter]="true"
  (dismiss)="dismiss()">
  <div modalTitle>
    <h2>{{ 'workMachines.newItem' | translate }}</h2>
  </div>

  <div modalDescription>
    <p>{{ 'workMachines.dialog.subtitle' | translate }}</p>
  </div>

  <form class="work-machine-dialog__form"
    [formGroup]="formGroup"
    (ngSubmit)="save()">
    <app-card>
      <app-section-header [title]="'workMachines.dialog.detailsTitle' | translate"
        [compact]="true"></app-section-header>
      <app-form-stack>
        <app-form-field [label]="'item.name' | translate"
          [compact]="true">
          <ion-item lines="inset">
            <ion-input autocapitalize="on"
              formControlName="name"></ion-input>
          </ion-item>
        </app-form-field>
      </app-form-stack>
    </app-card>

    <app-card>
      <app-section-header [title]="'workMachines.dialog.pricingTitle' | translate"
        [compact]="true"></app-section-header>
      <app-form-stack>
        <app-form-field [label]="'schedule.add.cost' | translate"
          [compact]="true">
          <ion-item lines="inset">
            <ion-input formControlName="cost"
              type="number"></ion-input>
          </ion-item>
        </app-form-field>

        <app-form-field [label]="'workMachines.period' | translate"
          [compact]="true">
          <div class="work-machine-dialog__chips">
            @for (option of periodOptions; track option.value) {
              <button class="work-machine-dialog__chip"
                type="button"
                [class.work-machine-dialog__chip--active]="formGroup.get('period')?.value === option.value"
                (click)="setPeriod(option.value)">
                <ion-icon [name]="option.icon"></ion-icon>
                <span>{{ option.labelKey | translate }}</span>
              </button>
            }
          </div>
        </app-form-field>
      </app-form-stack>
    </app-card>
  </form>

  <div modalFooter>
<ion-button fill="clear"
        color="medium"
        type="button"
        (click)="dismiss()">
        {{ 'general.cancel' | translate }}
      </ion-button>
      <ion-button color="light"
        fill="solid"
        type="button"
        [disabled]="formGroup.invalid"
        (click)="save()">
        {{ 'general.save' | translate }}
      </ion-button>
</div>
</app-modal-shell>
